import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map } from 'rxjs/operators';
import { UpdateService } from '../../service/update.service';

import * as taskDetailsActions from './task-detail.actions';

@Injectable()
export class TasksDetailEffects {
    constructor(private readonly actions$: Actions, private readonly updateService: UpdateService) { }

    getServiceData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(taskDetailsActions.getServiceData),
            exhaustMap(action =>
                this.updateService.getServiceData(action.idService).pipe(
                    map((response) => taskDetailsActions.getServiceDataSuccess({description: response.description}))
                )
            )
        )
    );

    getTaskData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(taskDetailsActions.getTaskData),
            exhaustMap(action =>
                this.updateService.getTaskData(action.idService).pipe(
                    map((response) => taskDetailsActions.getTaskDataSuccess({observation: response.observation}))
                )
            )
        )
    );
}
